<!-- Header: section label + action icons -->
<div class="notif-head">
  @if (panelView() === 'settings') {
  <button class="notif-back-pill" type="button" (click)="backToList()" aria-label="Back to notifications">
    <lucide-icon name="arrow-left" [size]="14" style="display: flex;"></lucide-icon>
    <span>Back</span>
  </button>
  } @else {
  <span class="notif-head-label">{{ headLabel() }}</span>
  }
  <div class="notif-head-actions">
    <button class="notif-ic-btn" type="button" data-tip="Settings" [class.is-active]="panelView() === 'settings'"
      (click)="toggleSettings()" aria-label="Notification settings">
      <lucide-icon name="settings" [size]="14" style="display: flex;"></lucide-icon>
    </button>
    <button class="notif-ic-btn" type="button" data-tip="Mark all as read" (click)="onMarkAllRead()"
      aria-label="Mark all as read">
      <lucide-icon name="check" [size]="16" style="display: flex;"></lucide-icon>
    </button>
    <div class="notif-filter-wrap" (click)="$event.stopPropagation()">
      <button class="notif-ic-btn" type="button" data-tip="Filters"
        [class.is-active]="showFilter() || activeFilter() !== 'all'" (click)="toggleFilter()"
        aria-label="Filter notifications">
        <lucide-icon name="filter" [size]="16" style="display: flex;"></lucide-icon>
      </button>
      @if (showFilter()) {
      <app-notifications-filter-dropdown [activeFilter]="activeFilter()" (filterChange)="onFilterChange($event)" />
      }
    </div>
  </div>
</div>

@if (panelView() === 'list') {
<!-- List view: time-grouped notifications -->
<div class="notif-content-area">
  @if (groupedNotifications().length > 0) {
  @for (group of groupedNotifications(); track group.label; let gi = $index) {
  <div class="notif-group">
    <!-- The first group's label lives in the header row (Figma) -->
    @if (gi > 0) {
    <span class="notif-group-label">{{ group.label }}</span>
    }
    @for (n of group.items; track n.id) {
    <div class="notif-item" [class.notif-item--unread]="n.read_at === null">
      <div class="notif-item-main" role="button" tabindex="0" (click)="onNotificationClick(n)"
        (keydown.enter)="onNotificationClick(n)" (keydown.space)="$event.preventDefault(); onNotificationClick(n)">
        <app-activity-item [notification]="n" />
      </div>
      @if (n.read_at === null) {
      <button class="notif-item-read" type="button" aria-label="Mark as read" title="Mark as read"
        (click)="onMarkRead(n, $event)">
        <lucide-icon name="check" [size]="16" style="display: flex;"></lucide-icon>
      </button>
      } @else {
      <button class="notif-item-read" type="button" aria-label="Mark as unread" title="Mark as unread"
        (click)="onMarkUnread(n, $event)">
        <lucide-icon name="rotate-ccw" [size]="14" style="display: flex;"></lucide-icon>
      </button>
      }
    </div>
    }
  </div>
  }
  } @else {
  <div class="notif-empty">
    <lucide-icon name="bell" [size]="35" class="notif-empty-icon" style="display: flex;"></lucide-icon>
    <span class="notif-empty-title">No notifications yet</span>
    <p class="notif-empty-text">When you receive updates, they'll appear here.</p>
  </div>
  }
</div>
} @else {
<!-- Settings view: In-app / Email per notification type -->
<div class="notif-content-area">
  @if (prefsLoading) {
  <div class="notif-settings-status">Loading settings…</div>
  } @else if (prefsError) {
  <div class="notif-settings-status">Couldn't load settings. Try again.</div>
  } @else {
  <div class="notif-pref-cols">
    <span class="notif-pref-col">In-app</span>
    <span class="notif-pref-col">Email</span>
  </div>
  @for (group of groupedSettingsPrefs; track group.label) {
  <div class="notif-pref-group-label">{{ group.label }}</div>
  @for (pref of group.prefs; track pref.type) {
  <div class="notif-pref-row">
    <span class="notif-pref-label">
      {{ pref.label }}
      @if (pref.description) {
      <span class="notif-pref-help" [attr.data-tip]="pref.description">
        <lucide-icon name="circle-question-mark" [size]="13" style="display: flex;"></lucide-icon>
      </span>
      }
    </span>
    <button class="notif-toggle" type="button" [class.notif-toggle--on]="pref.enabled" (click)="togglePref(pref)"
      [attr.aria-label]="(pref.enabled ? 'Disable ' : 'Enable ') + pref.label + ' in-app'">
      <span class="notif-toggle-thumb"></span>
    </button>
    <button class="notif-check" type="button" [class.notif-check--on]="pref.emailEnabled" (click)="toggleEmail(pref)"
      [attr.aria-label]="(pref.emailEnabled ? 'Disable ' : 'Enable ') + pref.label + ' email'">
      @if (pref.emailEnabled) {
      <lucide-icon name="check" [size]="12" style="display: flex;"></lucide-icon>
      }
    </button>
  </div>
  }
  }
  }
</div>
}
